// extracted by mini-css-extract-plugin
export default {"container":"empty-favorites_container__eM+vc","title":"empty-favorites_title__nuqhp","img":"empty-favorites_img__jQqsm","btn":"empty-favorites_btn__xHGkt"};